import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["once", "monthly", "input"]

  connect() {
    this.updateButtonStates(this.inputTarget.value)
  }

  selectFrequency(event) {
    const frequency = event.currentTarget.dataset.frequency
    this.inputTarget.value = frequency
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
    this.updateButtonStates(frequency)
  }

  updateButtonStates(selectedFrequency) {
    // Remove active state from all buttons
    var selectedButton = selectedFrequency === "once" ? this.onceTarget : this.monthlyTarget
    var unselectedButton = selectedFrequency === "monthly" ? this.onceTarget : this.monthlyTarget

    selectedButton.classList.remove("bg-white")
    selectedButton.classList.remove("text-gray-700")
    selectedButton.classList.add("bg-green-500")
    selectedButton.classList.add("text-gray-900")

    unselectedButton.classList.add("bg-white")
    unselectedButton.classList.add("text-gray-700")
    unselectedButton.classList.remove("bg-green-500")
    unselectedButton.classList.remove("text-gray-900")
  }
}
